export const getAuthHeader = () => {
  const user = JSON.parse(localStorage.getItem('WiseAcademy-user'))
  const token = user ? user.token : null
  return {
    headers: {
      Authorization: token ? `Bearer ${token}` : ''
    }
  }
}

export const getMultiPartAuthHeader = () => {
  const user = JSON.parse(localStorage.getItem('WiseAcademy-user'))
  const token = user ? user.token : null
  return {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: token ? `Bearer ${token}` : ''
    }
  }
}

export const getS3Credintials = () => ({
  accessKeyId: '',
  secretAccessKey: ''
})
